import { gql } from '@apollo/client';

const GET_OBSERVATION_REPORT_DOCUMENT_FILE_URL = gql`
  query GetObservationReportDocumentFileURL($eventId: Int!, $observedUserId: Int!) {
    observationReportFileUrl(eventId: $eventId, observedUserId: $observedUserId)
  }
`;

export default GET_OBSERVATION_REPORT_DOCUMENT_FILE_URL;
